<p-panel [toggleable]="true" [collapsed]="isPASComplete" toggler="header" header="Documents Details">
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
  </ng-template>
  @if (documents) {
      <div>
        @if (documents.length === 0) {
          <div class="p-field-checkbox-container p-field-checkbox">
            <p-checkbox
              binary="true"
              inputId="noOrderField"
              data-test-id="no-documents-checkbox"
              [ngModel]="true"
              [binary]="true"
              [disabled]="true"
            ></p-checkbox>
            <label for="noOrderField" class="font-semibold" data-test-id="no-documents-label">
              I do not have any clinical documents.
            </label>
          </div>
        }
      </div>
      @if (documents.length > 0) {
        <div>
          <p-table
            [value]="documents"
            [columns]="cols"
            responsiveLayout="scroll"
            data-test-id="documents-table"
            >
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th [ngStyle]="{ width: col.width }">
                    {{ col.header }}
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
              <tr>
                <td>
                  <div class="p-text-break-spaces break-all">
                    {{ document.documentFileName }}
                  </div>
                </td>
                <td>
                  <span
                    class="truncate"
                    [pTooltip]="document.documentTypes"
                    tooltipStyleClass="tooltip-xl-size"
                    tooltipPosition="bottom"
                    >
                    {{ document.documentTypes }}
                  </span>
                </td>
                <td>
                  <div class="p-text-break-word">
                    {{ document.description }}
                  </div>
                </td>
                <td>
                  <div class="p-text-break-word">
                    {{ document.fileMetaData.size }} Bytes
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
  }
</p-panel>
